import { Link as RouterLink } from "react-router-dom";
import { Button } from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { integrationInventoryAssetsUrl } from "~/pages/integrations/utils/integrationInventoryAssetsUrl";
import { useScope } from "~/hooks/useScope";

interface AwsIntegrationAssetsButtonProps {
  integrationMrn: string;
  show?: boolean;
}

export function AwsIntegrationAssetsButton({
  integrationMrn,
  show = false,
}: AwsIntegrationAssetsButtonProps) {
  const { spaceScope } = useScope();

  if (!show || !spaceScope) {
    return null;
  }

  return (
    <Button
      color="secondary"
      component={RouterLink}
      to={integrationInventoryAssetsUrl(spaceScope.id, integrationMrn).href}
      endIcon={<ArrowForwardIcon />}
    >
      Show Assets
    </Button>
  );
}
